import { GetStaticProps } from 'next';

import { HeroHeadline } from '@components/HeroHeadline';
import { ProductGrid } from '@components/ProductGrid';

import { getProductListingPage } from '@data/sanity/queries';
import { CmsProductListingPageDocument } from '@interfaces/common';
import { withSiteWideData } from '@utils/page';

interface ProductIndexPageProps {
	productListingPage: CmsProductListingPageDocument;
}

const ProductsPage: React.VFC<ProductIndexPageProps> = ({
	productListingPage,
}) => {
	const { heroHeadline, products } = productListingPage;

	return (
		<>
			<HeroHeadline {...heroHeadline} />
			<ProductGrid products={products} />
		</>
	);
};

export const getStaticProps: GetStaticProps =
	withSiteWideData<ProductIndexPageProps>(async ({ locale }) => {
		const productListingPage = await getProductListingPage(locale);

		if (!productListingPage) {
			return {
				notFound: true,
			};
		}

		return {
			props: {
				metadata: productListingPage.metadata || null,
				productListingPage,
			},
		};
	});

export default ProductsPage;
